import { newAPI } from '../../../services';

export const fetchClients = async url => {
  const result = await newAPI.get(url);
  return result.data;
}

export const fetchAllClients = async (userId, establishmentId, name) => {
  const result = await newAPI.get(`${userId}/establishment/${establishmentId}/clients/list/all?name=${name}`);
  return result.data
}

export const fetchClientInfo = async (userId, establishmentId, clientId) => {
  const result = await newAPI.get(`${userId}/establishment/${establishmentId}/clients/${clientId}/event-scheduling`);
  return result.data
}

export const closeInvoice = async (userId, establishmentId, clientId, invoiceDateTime) => {
  const result = await newAPI.post(`${userId}/establishment/${establishmentId}/invoices/close/${clientId}/${invoiceDateTime}`);
  return result.data;
}

export const fetchClientExporation = async url => {
  const result = await newAPI.get(url);
  return result.data;
}